import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=4cf165b0&scoped=true"
import script from "./sub-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./sub-menu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./sub-menu.vue?vue&type=style&index=0&id=4cf165b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf165b0",
  null
  
)

export default component.exports